import { Action as ReduxAction, handleActions } from "redux-actions";

import { PreferredLocale } from "../../../utils/locales";
import { IScormPackage, RequestState } from "../../types/common";
import { Action, IInitialData } from "../actions";

export interface IState {
  courseName: string | null;
  currentLocale: PreferredLocale;
  memberIds: string[];
  scormPackage: IScormPackage | null;
  scormPackageId: string | null;
  fetchInitialDataStatus: RequestState;
  patchScormPackageStatus: RequestState;
}

const INITIAL_STATE: IState = {
  courseName: null,
  currentLocale: PreferredLocale.en,
  fetchInitialDataStatus: RequestState.IDLE,
  memberIds: [],
  patchScormPackageStatus: RequestState.IDLE,
  scormPackage: null,
  scormPackageId: null,
};

const handleFetchInitialDataFailure = (state: IState): IState => ({
  ...state,
  courseName: null,
  fetchInitialDataStatus: RequestState.FAILED,
  memberIds: [],
  scormPackage: null,
});
const handleFetchInitialDataSuccess = (state: IState, action: ReduxAction<IInitialData>): IState => ({
  ...state,
  courseName: action.payload.courseName,
  fetchInitialDataStatus: RequestState.SUCCEEDED,
  memberIds: action.payload.memberIds,
  scormPackage: action.payload.scormPackage,
});
const patchScormPackage = (state: IState): IState => ({
  ...state,
  patchScormPackageStatus: RequestState.PENDING,
});
const handlePatchScormPackageSuccess = (state: IState): IState => ({
  ...state,
  patchScormPackageStatus: RequestState.SUCCEEDED,
});
const handlePatchScormPackageFailure = (state: IState): IState => ({
  ...state,
  patchScormPackageStatus: RequestState.FAILED,
});
const handleRefreshScormPackageSuccess = (state: IState, action: ReduxAction<IScormPackage>): IState => ({
  ...state,
  scormPackage: action.payload,
});
const handleRefreshScormPackageFailure = (state: IState): IState => ({
  ...state,
});
const setCurrentLocale = (state: IState, action: ReduxAction<PreferredLocale>): IState => ({
  ...state,
  currentLocale: action.payload,
});
const mount = (_: IState, action: ReduxAction<string>): IState => ({
  ...INITIAL_STATE,
  fetchInitialDataStatus: RequestState.PENDING,
  scormPackage: null,
  scormPackageId: action.payload,
});
const unmount = (_: IState): IState => INITIAL_STATE;

export default handleActions<IState, string | IInitialData | IScormPackage>(
  {
    [Action.MOUNT]: mount,
    [Action.HANDLE_FETCH_INITIAL_DATA_FAILURE]: handleFetchInitialDataFailure,
    [Action.HANDLE_FETCH_INITIAL_DATA_SUCCESS]: handleFetchInitialDataSuccess,
    [Action.PATCH_SCORM_PACKAGE]: patchScormPackage,
    [Action.HANDLE_PATCH_SCORM_PACKAGE_FAILURE]: handlePatchScormPackageFailure,
    [Action.HANDLE_PATCH_SCORM_PACKAGE_SUCCESS]: handlePatchScormPackageSuccess,
    [Action.HANDLE_REFRESH_SCORM_PACKAGE_SUCCESS]: handleRefreshScormPackageSuccess,
    [Action.HANDLE_REFRESH_SCORM_PACKAGE_FAILURE]: handleRefreshScormPackageFailure,
    [Action.SET_CURRENT_LOCALE]: setCurrentLocale,
    [Action.UNMOUNT]: unmount,
  },
  INITIAL_STATE
);
